var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 14a1.468 1.468 0 0 0 1.055-.445l9.645-9.84a1.001 1.001 0 0 0 0-1.43 1 1 0 0 0-1.415 0L5 11.775l-3.3-3.47a1 1 0 0 0-1.41 0 1 1 0 0 0 0 1.43l3.65 3.825A1.5 1.5 0 0 0 5 14Z",
    clipRule: "evenodd"
  })));
};
export default SvgCheckmark;